import {
  FiGlobe,
  FiLayers,
  FiMessageCircle,
  FiMessageSquare,
  FiMonitor,
  FiMousePointer,
  FiTarget,
  FiUser,
} from "react-icons/fi";

export const stats = [
  {
    icon: FiMessageCircle,
    label: "Collaboration",
    value: "1:1",
    desc: "You talk directly to the person working on your project.",
  },
  {
    icon: FiGlobe,
    label: "Where we work",
    value: "2",
    desc: "Germany & Indonesia for flexible collaboration.",
  },
  {
    icon: FiLayers,
    label: "Perspective",
    value: "Full",
    desc: "Tech, design, and marketing view in one partner.",
  },
];

export const fitCards = [
  {
    Icon: FiLayers,
    title: "Your online presence feels scattered",
    desc: "You have an offer, content, ideas, maybe even a website, but everything does not feel connected yet.",
  },
  {
    Icon: FiMousePointer,
    title: "DIY is slowing you down",
    desc: "You can do some things yourself, but the details, structure, and technical decisions take too much energy.",
  },
  {
    Icon: FiTarget,
    title: "A big agency feels too much",
    desc: "You want quality and guidance, but not a bloated process, complicated meetings, or unnecessary overhead.",
  },
  {
    Icon: FiMessageSquare,
    title: "You want one clear partner",
    desc: "Someone who understands design, websites, technical setup, and how it should support your business.",
  },
];

export const whyO3SItems = [
  {
    title: "Direct 1:1 Collaboration",
    text: "Work directly with the person designing and building your website without unnecessary handoffs or middlemen.",
    icon: FiUser,
  },
  {
    title: "International Perspective",
    text: "Experience across the German and Indonesian markets, paired with an international mindset for businesses that want to reach beyond borders.",
    icon: FiGlobe,
  },
  {
    title: "Fully Online Process",
    text: "From the first conversation to launch and ongoing support, the entire collaboration is handled efficiently online.",
    icon: FiMonitor,
  },
  {
    title: "One Unified Partner",
    text: "Technology, design, and marketing are planned together, creating one consistent strategy and digital presence.",
    icon: FiLayers,
  },
];
